import { ACTION_CREATE } from '../../request';
import { Voter } from '../voter';

export class SubscriptionFormFieldVoter extends Voter {
    supports(request) {
        return request.role === 'basic' && request.resource === 'subscription-form-field';
    }

    vote(request) {
        if (request.includes(ACTION_CREATE) && !this.canCreate(request)) {
            return false;
        }
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    canCreate({ subject }) {
        const lockedItem = subject?.items?.find(({ type }) => type !== 'email');

        return !lockedItem;
    }
}
